import React from "react";
import LightSweep from "./LightSweep";

interface Props {
  /** Glint colour (rgba), default bright white */
  color?: string;
  /** Sweep cycle duration seconds, default 2.4 */
  dur?: number;
}

/**
 * PanelGlint — a fast narrow highlight band simulating a solar-panel reflection.
 * Delegates to LightSweep with a narrow beam and steep angle.
 */
const PanelGlint: React.FC<Props> = ({
  color = "rgba(255,255,255,0.7)",
  dur = 2.4,
}) => <LightSweep color={color} duration={dur} />;

export default PanelGlint;
